import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/loading_spinner';

import DuplicatesPageHeader from './duplicates_page_header';
import DuplicatesPageTopbar from './duplicates_page_topbar';
import DuplicatesTable from './duplicates_table';

import { getDuplicatePropertiesCount, isLoading } from '../../store/selectors/duplicates';
import DuplicatesPagination from 'bundles/research/index/properties/duplicates/duplicates_pagination';

function renderEmptyState() {
  return (
    <div className="no-results-panel" name="no-results-panel">
      <FontAwesomeIcon className="text-muted my-4" icon={faSearch} size="5x" />
      <h4 className="mt-4">
        <strong className="text-lg">No duplicate properties found</strong>
      </h4>
    </div>
  );
}

function renderTable() {
  return (
    <React.Fragment>
      <DuplicatesTable />
      <DuplicatesPagination />
    </React.Fragment>
  );
}

function renderResults(isLoading, totalCount) {
  if (isLoading) return <LoadingSpinner />;
  if (totalCount > 0) return renderTable();
  return renderEmptyState();
}

export function DuplicatePropertiesView({ isLoading, totalCount }) {
  return (
    <React.Fragment>
      <DuplicatesPageHeader />
      <DuplicatesPageTopbar />
      {renderResults(isLoading, totalCount)}
    </React.Fragment>
  );
}

DuplicatePropertiesView.propTypes = {
  isLoading: PropTypes.bool,
  totalCount: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  isLoading: isLoading(state),
  totalCount: getDuplicatePropertiesCount(state)
});

export default connect(mapStateToProps)(DuplicatePropertiesView);
